import React from 'react';
import { PropTypes } from 'prop-types';

const NavItemDesktopPromotion = props => (
  <a href={props.tRoute(props.headerHref)}
    className="mmd__column-image-text">
    <div className="mmd__promotion-image">
      <img className="img-fluid lazyload" data-src={props.menuSubitems[0].imageUrl} />
    </div>
    <div className="mmd__content-text">
      <p className="mmd__special">{props.headerLabel}</p>
      <p className="mmd__short-description">{props.footerLabel}</p>
    </div>
  </a>
);

NavItemDesktopPromotion.propTypes = {
  headerLabel: PropTypes.string,
  footerLabel: PropTypes.string,
  headerHref: PropTypes.string,
  menuSubitems: PropTypes.arrayOf(PropTypes.shape({
    imageUrl: PropTypes.string,
  })),
};

export default NavItemDesktopPromotion;



// WEBPACK FOOTER //
// ./src/Nav/NavItemDesktopPromotion.js